import { Injectable } from '@angular/core';

import { GraphqlService } from '../graphql/graphql.service';
import { SecurityService } from '../security/security.service';
import { SystemSettings } from '../shared/system-settings';

/** Loads SystemSettings from the API once a user is logged in - the query requires an access token. */
@Injectable({
	providedIn: 'root',
})
export class SystemSettingsService {
	private loadPromise: Promise<void>;

	constructor(
		private graphqlService: GraphqlService,
		private securityService: SecurityService,
	) {
		this.securityService.authFieldsSetEvent.subscribe(() => this.load());
	}

	/** Does nothing until a user is logged in; afterward it fetches the settings once. */
	public load(): Promise<void> {
		if (!this.securityService.authFields?.token) {
			return Promise.resolve();
		}

		this.loadPromise ??= this.fetchSettings();

		return this.loadPromise;
	}

	private async fetchSettings(): Promise<void> {
		try {
			const result = await this.graphqlService.getSystemSettings({ name: 'file-max-size' });

			const fileMaxSize = result.data.settings.message.find(s => s.name === 'file-max-size')?.value;
			const fileMaxSizeBytes = parseInt(fileMaxSize, 10);

			if (fileMaxSizeBytes > 0) {
				SystemSettings.fileMaxSizeBytes = fileMaxSizeBytes;
			}
		} catch (e) {
			console.error(e);
			// let the next login retry instead of keeping the fallback for the rest of the session
			this.loadPromise = null;
		}
	}
}
